import { AuthenticatedLayout } from "../../layouts";
import { ChequeSettingsSetup } from "../../components/ChequeSettingsSetup";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

export const ChequeSettingsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Cheque Settings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Cheque Settings", navigateTo: "/settings/cheque/list" },
        // { text: "Create Cheque Settings", navigateTo: "/settings/cheque/setup" }
      ]}
      mainContents={<ChequeSettingsSetup />}
    />
  );
};
